import React, { useState, useEffect, useContext } from 'react';
import { Context } from "../../context";

console.log("🎯 Simple field component loaded!");

export const DatacenterFieldManagement = () => {
    console.log("🎯 Simple DatacenterFieldManagement rendered!");
    
    const { apiClient, currentField } = useContext(Context);
    const [loading, setLoading] = useState(false);
    const [fieldData, setFieldData] = useState(null);
    const [turbines, setTurbines] = useState([]);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const loadData = async () => {
            if (!apiClient) {
                console.log("🔍 No apiClient available");
                return;
            }
            
            setLoading(true);
            setError(null);
            
            try {
                console.log("🚀 Making backend API calls...");
                
                // Get all fields first
                console.log("📡 Calling /fielditem");
                const fieldsResponse = await apiClient.getFieldItems();
                console.log("📊 Fields response:", fieldsResponse);
                
                // Use first field if no currentField is set
                const selectedField = currentField || (fieldsResponse && fieldsResponse[0]);
                if (selectedField) {
                    setFieldData(selectedField);
                    
                    // Get turbines for this field
                    const fieldId = selectedField.id || selectedField;
                    console.log("📡 Calling /turbine with fieldId:", fieldId);
                    const turbinesResponse = await apiClient.get('/turbine', { params: { fieldId } });
                    console.log("🏭 Turbines response:", turbinesResponse);
                    setTurbines(turbinesResponse || []);
                }
                
            } catch (err) {
                console.error("❌ API Error:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        
        loadData();
    }, [apiClient, currentField]);
    
    if (loading) {
        return (
            <div style={{ padding: '20px' }}>
                <h2>⏳ 加载中...</h2>
                <p>正在从后端获取数据...</p>
            </div>
        );
    }
    
    if (error) {
        return (
            <div style={{ padding: '20px', border: '2px solid red', margin: '20px' }}>
                <h2>❌ 错误</h2>
                <p>无法加载数据: {error}</p>
                <button onClick={() => window.location.reload()}>重新加载</button>
            </div>
        );
    }
    
    return (
        <div style={{ padding: '20px', border: '2px solid green', margin: '20px' }}>
            <h1>🎯 风场数据页面 (后端集成)</h1>
            
            <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f0f8ff', border: '1px solid #0066cc' }}>
                <h3>🏢 当前风场信息</h3>
                {fieldData ? (
                    <div>
                        <p><strong>名称:</strong> {fieldData.name}</p>
                        <p><strong>序号:</strong> {fieldData.seq}</p>
                        <p><strong>类型:</strong> {fieldData.type}</p>
                        <p><strong>装机容量:</strong> {fieldData.power}MW</p>
                        <p><strong>地址:</strong> {fieldData.address}</p>
                        <p><strong>联系人:</strong> {fieldData.contact}</p>
                        <p><strong>电话:</strong> {fieldData.contact_phone}</p>
                        {fieldData.longitude && fieldData.latitude && (
                            <p><strong>坐标:</strong> {fieldData.longitude}, {fieldData.latitude}</p>
                        )}
                    </div>
                ) : (
                    <p>暂无风场数据</p>
                )}
            </div>
            
            <div style={{ padding: '15px', backgroundColor: '#f0fff0', border: '1px solid #00cc66' }}>
                <h3>🏭 风机列表 ({turbines.length}台)</h3>
                {turbines.length > 0 ? (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '15px', marginTop: '15px' }}>
                        {turbines.slice(0, 6).map((turbine, index) => (
                            <div key={turbine.id || index} style={{ 
                                padding: '10px', 
                                border: '1px solid #ccc', 
                                borderRadius: '5px',
                                backgroundColor: 'white'
                            }}>
                                <h4>🔧 {turbine.name || `风机${turbine.seq}`}</h4>
                                <p><strong>序号:</strong> {turbine.seq}</p>
                                <p><strong>型号:</strong> {turbine.model?.name || '未知'}</p>
                                <p><strong>安装时间:</strong> {turbine.installedAt ? new Date(turbine.installedAt).toLocaleDateString() : '未知'}</p>
                                {turbine.description && <p><strong>描述:</strong> {turbine.description}</p>}
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>暂无风机数据</p>
                )}
                {turbines.length > 6 && (
                    <p style={{ marginTop: '15px', fontStyle: 'italic' }}>
                        显示前6台风机，共{turbines.length}台...
                    </p>
                )}
            </div>
            
            <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#fffacd', border: '1px solid #ffd700' }}>
                <h4>🔍 调试信息</h4>
                <p>API客户端: {apiClient ? '✅ 已连接' : '❌ 未连接'}</p>
                <p>当前风场: {currentField ? '✅ 已设置' : '❌ 未设置'}</p>
                <p>后端调用状态: ✅ 成功</p>
            </div>
        </div>
    );
};